'use strict';

exports.__esModule = true;
function _interopRequire(obj) {
  return obj && obj.__esModule ? obj['default'] : obj;
}
var _Motion = require('./Motion');
exports.Motion = _interopRequire(_Motion);
var _StaggeredMotion = require('./StaggeredMotion');
exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
var _TransitionMotion = require('./TransitionMotion');
exports.TransitionMotion = _interopRequire(_TransitionMotion);
var _spring = require('./spring');
exports.spring = _interopRequire(_spring);
var _presets = require('./presets');
exports.presets = _interopRequire(_presets);
var _stripStyle = require('./stripStyle');
exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = require('./reorderKeys');
exports.reorderKeys = _interopRequire(_reorderKeys);